import React, { useCallback, useEffect, useRef, useState } from "react";
import { Row, Col, Button, Container } from "reactstrap";
import classnames from "classnames";
import { connect } from "react-redux";

import {
  Form,
  Intl,
  Select,
  ConfirmationModal,
  SaveFavouriteModal,
  ModalInfo,
} from "components";
import { required } from "config/InputErrors";
import Message from "components/Pages/Answering/Message";
import Mailbox from "components/Pages/Answering/Mailbox";
import SettingsActions from "store/reducers/Settings";
import AccountDirectDialService from "api/AccountDirectDial";
import { getCountryName, handlePromise } from "utils";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import "./index.css";

const Answering = ({
  data,
  phoneNumbers,
  isLoading,
  onSubmit,
  onFetchPhoneNumber,
  toggleLoading,
  errorNoAudiosModalVisible,
  setErrorNoAudiosModalVisible,
  isPhoneNumbersLoading,
}) => {
  const [confirmTtsModalOpened, setConfirmTtsOpened] = useState(false);
  const formRef = useRef(null);
  const formValuesRef = useRef(null);
  const favAudioFieldRef = useRef(null);
  const [saveFavouriteModalOpened, setSaveFavouriteModalOpened] =
    useState(false);
  const [customAlert, setCustomAlert] = useState(false);
  const [confirmSubmit, setConfirmSubmit] = useState(false);
  const [validateCheck, setValidateCheck] = useState({
    message: false,
    voicemail: false,
  });

  const toggleConfirmTtsModal = useCallback(() => {
    setConfirmTtsOpened(!confirmTtsModalOpened);
  }, [confirmTtsModalOpened]);

  // useEffect(() => {
  //   if (isPhoneNumbersLoading !== undefined && !isPhoneNumbersLoading) {
  //     setCustomAlert(
  //       isPhoneNumbersLoading !== undefined &&
  //         !isPhoneNumbersLoading &&
  //         phoneNumbers.length === 0
  //     );
  //   }
  // }, [isPhoneNumbersLoading, phoneNumbers]);

  const phoneNumber = phoneNumbers.map((item) => ({
    id: item.id,
    name: `${item.directDial.number} | 
    ${getCountryName(
      item.directDial.country
    )} - ${item.directDial.area}`
    ,
  }));

  const fetchData = useCallback(async () => {
    const [, response, responseData] = await handlePromise(
      AccountDirectDialService.getDdis({ limit: 0 })
    );
    if (!response.ok) {
      return 0;
    }
    return responseData.total;
  }, []);

  useEffect(() => {
    fetchData().then((res) => {
      setCustomAlert(!(res > 0));
    });
  }, [fetchData]);

  useEffect(() => {
    if (data && data.id) {
      setValidateCheck({
        message: data.message || false,
        voicemail: data.voicemail || false,
      });
      formRef.current.initialize(data);
    }
  }, [data]);

  const toggleSaveFavouriteModal = useCallback(
    (audioField) => {
      favAudioFieldRef.current = audioField;
      setSaveFavouriteModalOpened(!saveFavouriteModalOpened);
    },
    [saveFavouriteModalOpened]
  );

  const saveFavourite = useCallback(
    async (dataToSend) => {
      if (data && data.id) {
        toggleLoading(true);
        const [errors, response] = await handlePromise(
          AccountDirectDialService.saveFavouriteAudio(data.id, {
            id: formValuesRef.current[favAudioFieldRef.current].id,
            originalName: dataToSend.originalName,
          })
        );
        toggleLoading(false);
        if (!response.ok) return errors;

        toggleSaveFavouriteModal();
      }
    },
    [data, toggleSaveFavouriteModal, toggleLoading]
  );

  const handleCustomAlert = (check) => {
    if (!isPhoneNumbersLoading && phoneNumbers.length === 0) {
      setCustomAlert(check);
    }
  };

  const getText = () => {
    if (phoneNumbers.length === 0) {
      return (
        <>
          <Intl id="errorNoNumber1" />
          <Link to="/in/administration/hired-numbers">
            {" "}
            <Intl id="administrator" />{" "}
          </Link>
          <Intl id="errorNoNumber2" />
        </>
      );
    }
    if (!validateCheck.message && !validateCheck.voicemail) {
      return <Intl id="errorUncheck" />;
    }
  };

  const closeConfirmSubmitModal = useCallback(() => {
    setConfirmSubmit(false);
  }, []);

  const onSubmitConfirmAlert = () => {
    onSubmit(formValuesRef.current);
    setConfirmSubmit(false);
  };

  const onSubmitMiddleWare = (e) => {
    if (!validateCheck.message && !validateCheck.voicemail) {
      // setCustomAlert( true );
      setConfirmSubmit(true);
      // onSubmit( e );
    } else {
      onSubmit(e);
    }
  };

  return (
    <Form
      defaultValues={data}
      showErrorsInHeader
      onSubmit={onSubmitMiddleWare}
      validate={(formValues) => {
        const errors = {};
        if (formValues.voicemail && !formValues.voicemailMediaAudioSrc) {
          errors.voicemailMediaAudioSrc = required(
            errors.voicemailMediaAudioSrc
          );
        }
        if (formValues.message) {
          if (!formValues.messageType) {
            errors.messageType = required(errors.messageType);
          }
          if (!formValues.messageMediaAudioSrc) {
            errors.messageMediaAudioSrc = required(errors.messageMediaAudioSrc);
          }
        }
        return errors;
      }}
      body={(form) => {
        formRef.current = form;
        const { values } = form.getState();
        formValuesRef.current = values;
        const formDisabled = !values || !values.id;
        const messageDisabled = formDisabled || !values.message;
        const mailboxDisabled = formDisabled || !values.voicemail;
        
        return (
          <Container
            fluid
            className={classnames("mt-3", {
              "app-component-loading": isLoading,
            })}
          >
            {/* <Row>
              <Col md={{ size: 8, offset: 2 }} className="d-none d-md-block">
                <Select
                  placeholder="selectAnswerNumber"
                  field="id"
                  // labelKey="directDial.number"
                  options={phoneNumber}
                  onChange={onFetchPhoneNumber}
                />
              </Col>
              <Col md={5} className="d-md-none">
                <Select
                  placeholder="selectAnswerNumber"
                  field="id"
                  // labelKey="directDial.number"
                  options={phoneNumber}
                  onChange={onFetchPhoneNumber}
                />
              </Col>
            </Row> */}
            <Row className="align-items-center">
              <Col xs={12} md={7} lg={10} className="mb-2 mb-md-0">
                <Row className="align-items-center">
                  <Col md={3} className="pt-1 pt-lg-0"></Col>
                  <Col md={9} className="pt-1 pt-lg-0 myPl-6">
                    <Select
                      placeholder="selectAnswerNumber"
                      field="id"
                      // labelKey="directDial.number"
                      options={phoneNumber}
                      onChange={onFetchPhoneNumber}
                    />
                  </Col>
                </Row>
              </Col>
              <Col xs={12} md={5} lg={4}></Col>
            </Row>

            <SweetAlert
              title=""
              onConfirm={() => {}}
              custom
              show={customAlert}
              showCloseButton
              customButtons={<></>}
              onCancel={() => setCustomAlert(false)}
              style={{ width: "fit-content" }}
            >
              <span style={{ color: "#000000", padding: "0 5rem" }}>
                {getText()}
              </span>
            </SweetAlert>

            <Message
              messageDisabled={messageDisabled}
              formDisabled={formDisabled}
              values={values}
              onFormChange={form.change}
              onToggleConfirmTtsModal={toggleConfirmTtsModal}
              onToggleSaveFavouriteModal={toggleSaveFavouriteModal}
              showAdmistrationModal={
                !isPhoneNumbersLoading && phoneNumbers.length === 0
              }
              handleCustomAlert={handleCustomAlert}
              // eslint-disable-next-line max-len
              validateCheck={(checked) =>
                setValidateCheck((prevstate) => ({
                  ...prevstate,
                  message: checked,
                }))
              }
            />

            <Mailbox
              mailboxDisabled={mailboxDisabled}
              formDisabled={formDisabled}
              values={values}
              onFormChange={form.change}
              onToggleConfirmTtsModal={toggleConfirmTtsModal}
              onToggleSaveFavouriteModal={toggleSaveFavouriteModal}
              showAdmistrationModal={
                !isPhoneNumbersLoading && phoneNumbers.length === 0
              }
              handleCustomAlert={handleCustomAlert}
              // eslint-disable-next-line max-len
              validateCheck={(checked) =>
                setValidateCheck((prevstate) => ({
                  ...prevstate,
                  voicemail: checked,
                }))
              }
            />

            <Row className="mt-5">
              <Col className="text-center">
                <Button
                  color="app-default"
                  size="app-sm"
                  className="font-weight-bold"
                  disabled={formDisabled}
                >
                  <Intl id="saveChanges" />
                </Button>
              </Col>
            </Row>

            {confirmSubmit && (
              <ConfirmationModal
                title="errorUncheck"
                subtitle="deleteModal.confirmation"
                open={confirmSubmit}
                onClose={closeConfirmSubmitModal}
                onConfirm={() => onSubmitConfirmAlert(values)}
                okLabel="okBtn"
              />
            )}

            {confirmTtsModalOpened && (
              <ConfirmationModal
                title={
                  <span>
                    <Intl id="answeringTtsTitle" />{" "}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="http://www.fromtexttospeech.com/"
                    >
                      <Intl id="here" />
                    </a>
                    .
                  </span>
                }
                translateTitle={false}
                open={confirmTtsModalOpened}
                confirmClose
                onConfirm={toggleConfirmTtsModal}
                okLabel="save"
              />
            )}

            {saveFavouriteModalOpened && (
              <SaveFavouriteModal
                values={{
                  // eslint-disable-next-line no-nested-ternary
                  originalName: values[favAudioFieldRef.current]
                    ? // eslint-disable-next-line no-nested-ternary
                      values[favAudioFieldRef.current].userDefineName 
                      ? values[favAudioFieldRef.current].userDefineName.replace(/.mp3/g, "")
                      : values[favAudioFieldRef.current].originalName
                      ? values[favAudioFieldRef.current].originalName.replace(
                          /.mp3/g,
                          ""
                        )
                      : values[favAudioFieldRef.current].name
                      ? values[favAudioFieldRef.current].name.replace(
                          /.mp3/g,
                          ""
                        )
                      : null
                    : null,
                }}
                open={saveFavouriteModalOpened}
                onClose={toggleSaveFavouriteModal}
                onSubmit={saveFavourite}
              />
            )}
            <ModalInfo
              open={errorNoAudiosModalVisible}
              size="md"
              onClose={() => {
                setErrorNoAudiosModalVisible(false);
              }}
            >
              <div className="pb-5 text-center">
                <Intl id="errorNoAudios" />
              </div>
            </ModalInfo>
          </Container>
        );
      }}
    />
  );
};

const mapDispatchToProps = {
  toggleLoading: SettingsActions.toggleLoading,
};
export default connect(null, mapDispatchToProps)(Answering);
